// extracted by mini-css-extract-plugin
export default {"closeBtnContainer":"MultiFormAlergenos_closeBtnContainer__qdFsx"};